import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { THEME_COLORS } from "constants/theme";
import { MINI_SIDENAV_WIDTH, SIDENAV_WIDTH } from "cxfcomponents/portalShell";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { miniSidenav } = ownerState;
  const isDark = theme.palette.mode === "dark";

  return {
    "& .MuiDrawer-paper": {
      top: 0,
      left: 0,
      height: "100vh",
      width: miniSidenav ? MINI_SIDENAV_WIDTH : SIDENAV_WIDTH,
      margin: 0,
      borderRadius: 0,
      border: "none",
      borderRight: "1px solid rgba(140, 150, 170, 0.2)",
      boxShadow: "none",
      overflowX: "hidden",
      backgroundColor: isDark ? THEME_COLORS.DARK.NAVBAR_BG : THEME_COLORS.LIGHT.NAVBAR_BG,
      transform: "translateX(-320px)",
      transition: theme.transitions.create(["width", "transform"], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.standard,
      }),
      [theme.breakpoints.up("xl")]: {
        transform: "translateX(0)",
      },
    },
  };
});
